export const SET_HISTORICO_DESVIOS_CORRECOES_DATA = 'SET_HISTORICO_DESVIOS_CORRECOES_DATA';
export const SET_HISTORICO_DESVIOS_CORRECOES_ERROR = 'SET_HISTORICO_DESVIOS_CORRECOES_ERROR';
export const SET_DESVIOS_DATA = 'SET_DESVIOS_DATA';
export const SET_DESVIOS_ERROR = 'SET_DESVIOS_ERROR';
